module.exports = __webpack_public_path__ + "static/discover-logo-small-206ec2e8da245bde35813cb862bb562e.svg";